import { render } from "./openwindow.vue?vue&type=template&id=f494819a&scoped=true"
import script from "./openwindow.vue?vue&type=script&lang=js"
export * from "./openwindow.vue?vue&type=script&lang=js"

import "./openwindow.vue?vue&type=style&index=0&id=f494819a&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit_master\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f494819a"]])

export default __exports__